/**
 * SCP Wallet brand mark — a hexagon (the protocol/container) enclosing a
 * keyhole (sovereign access: the user holds the only key to their context).
 * The path uses `currentColor`; default tint is the Cere brand violet, so it
 * tints via the `color` prop/style like any icon.
 */
import type { CSSProperties } from 'react';

export function LogoMark({
  size = 28,
  color = 'var(--c-violet)',
  style,
}: {
  size?: number;
  color?: string;
  style?: CSSProperties;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 442.687 442.687"
      fill="none"
      role="img"
      aria-label="SCP Wallet"
      style={{ color, display: 'block', ...style }}
    >
      <g fill="currentColor">
        <path d="M220.036,146.886c19.733,0,35.771,16.042,35.771,35.771c0,12.974-7.053,24.962-18.397,31.273l-6.751,3.756l1.932,7.481 l22.885,88.124h-66.585l10.082-36.443l13.563-49.086l2.366-8.589l-8.258-3.336c-13.598-5.482-22.377-18.52-22.377-33.181 C184.275,162.928,200.316,146.886,220.036,146.886 M220.036,136.897c-25.26,0-45.75,20.485-45.75,45.759 c0,19.217,11.848,35.668,28.63,42.452c-27.143,98.182,0,0-27.143,98.182c3.438,0,92.616,0,92.616,0s0,0-26.123-100.62 c14.027-7.813,23.519-22.797,23.519-40.004C265.795,157.373,245.311,136.897,220.036,136.897L220.036,136.897z" />
        <path d="M411.939,108.79L219.158,0L28.562,112.564l2.189,221.338l192.782,108.784l190.592-112.559L411.939,108.79z M218.865,31.376 c8.73,0,15.812,7.082,15.812,15.812s-7.082,15.812-15.812,15.812c-8.74,0-15.822-7.082-15.822-15.812 S210.125,31.376,218.865,31.376z M73.189,330.811c-8.74,0-15.822-7.082-15.822-15.812s7.082-15.812,15.822-15.812 c8.73,0,15.812,7.082,15.812,15.812S81.919,330.811,73.189,330.811z M73.189,148.515c-8.74,0-15.822-7.082-15.822-15.812 s7.082-15.812,15.822-15.812c8.73,0,15.812,7.082,15.812,15.812S81.919,148.515,73.189,148.515z M226.357,408.449 c-8.741,0-15.822-7.082-15.822-15.803c0-8.74,7.082-15.822,15.822-15.822c8.73,0,15.812,7.082,15.812,15.822 C242.169,401.367,235.088,408.449,226.357,408.449z M164.678,331.445c0,0-0.727-1.951,28.65-97.068 c-18.12-9.75-30.459-28.874-30.459-50.891c0-31.898,25.855-57.748,57.748-57.748c31.894,0,57.743,25.85,57.743,57.748 c0,20.197-10.389,37.955-26.104,48.275c28.522,97.713,29.312,99.684,29.312,99.684H164.678L164.678,331.445z M376.189,327.718 c-8.74,0-15.822-7.082-15.822-15.822c0-8.721,7.082-15.803,15.822-15.803c8.729,0,15.812,7.082,15.812,15.803 C392.001,320.636,384.919,327.718,376.189,327.718z M376.189,145.418c-8.74,0-15.822-7.082-15.822-15.812 s7.082-15.812,15.822-15.812c8.729,0,15.812,7.082,15.812,15.812S384.919,145.418,376.189,145.418z" />
      </g>
    </svg>
  );
}

/** Mark + "SCP Wallet" wordmark lockup, used in the app shell header. */
export function LogoLockup({ height = 26, color = 'var(--text-primary)' }: { height?: number; color?: string }) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 10, color }}>
      <LogoMark size={height} color="var(--c-violet)" />
      <span
        style={{ font: `600 ${Math.round(height * 0.74)}px/1 var(--font-display)`, letterSpacing: '-0.01em', color }}
      >
        SCP&nbsp;Wallet
      </span>
    </span>
  );
}
